"use strict";

var _objectSpread = require("/builds/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");
var _slicedToArray = require("/builds/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var line_height_1 = __importDefault(require("line-height"));
var preact_1 = require("preact");
var preact_motion_1 = require("preact-motion");
var hooks_1 = require("preact/hooks");
var ScrollBar_1 = __importDefault(require("./ScrollBar"));
var utils_1 = require("./utils");
var eventTypes = {
  wheel: "wheel",
  api: "api",
  touch: "touch",
  touchEnd: "touchEnd",
  mousemove: "mousemove",
  keyPress: "keypress"
};
function ScrollArea(props) {
  var _ref = (0, hooks_1.useState)({
      topPosition: 0,
      leftPosition: 0,
      realHeight: 0,
      containerHeight: 10,
      realWidth: 10,
      containerWidth: 10,
      eventType: eventTypes.api
    }),
    _ref2 = _slicedToArray(_ref, 2),
    state = _ref2[0],
    setState = _ref2[1];
  var contentRef = (0, hooks_1.useRef)(null);
  var wrapperRef = (0, hooks_1.useRef)(null);
  var getLineHeightPx = (0, hooks_1.useCallback)(function () {
    return contentRef ? (0, line_height_1.default)(contentRef.current) : 14;
  }, []);
  (0, hooks_1.useEffect)(function () {
    props.contentWindow.addEventListener("resize", handleWindowResize);
    setSizesToState();
    return function () {
      props.contentWindow.removeEventListener("resize", handleWindowResize);
    };
  }, []);
  //componentDidUpdate
  (0, hooks_1.useEffect)(function () {
    setSizesToState();
  });
  /**
   * state 갱신
   */
  var setStateFromEvent = (0, hooks_1.useCallback)(function (newState) {
    var eventType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    if (props.onScroll) {
      props.onScroll(newState);
    }
    setState(function (prevState) {
      return _objectSpread(_objectSpread(_objectSpread({}, prevState), newState), {}, {
        eventType: eventType
      });
    });
  }, [state]);
  var getModifiedPositionsIfNeeded = (0, hooks_1.useCallback)(function (sizes) {
    var newState = _objectSpread({}, sizes);
    var bottomPosition = newState.realHeight - newState.containerHeight;
    if (state.topPosition >= bottomPosition) {
      newState.topPosition = canScrollY(sizes) ? (0, utils_1.positiveOrZero)(bottomPosition) : 0;
    }
    var rightPosition = newState.realWidth - newState.containerWidth;
    if (state.leftPosition >= rightPosition) {
      newState.leftPosition = canScrollX(newState) ? (0, utils_1.positiveOrZero)(rightPosition) : 0;
    }
    return newState;
  }, [state]);
  /**
   * 사이즈 측정
   */
  var computeSizes = (0, hooks_1.useCallback)(function () {
    var realHeight = contentRef.current.offsetHeight;
    var containerHeight = wrapperRef.current.offsetHeight;
    var realWidth = contentRef.current.offsetWidth;
    var containerWidth = wrapperRef.current.offsetWidth;
    return {
      realHeight: realHeight,
      containerHeight: containerHeight,
      realWidth: realWidth,
      containerWidth: containerWidth
    };
  }, [state.topPosition, state.leftPosition]);
  /**
   * 사이즈가 변경됐을경우
   */
  var setSizesToState = (0, hooks_1.useCallback)(function () {
    var sizes = computeSizes();
    if (sizes.realHeight !== state.realHeight || sizes.realWidth !== state.realWidth) {
      setStateFromEvent(getModifiedPositionsIfNeeded(sizes));
    }
  }, [state, computeSizes, setStateFromEvent, getModifiedPositionsIfNeeded]);
  /**
   * 가능한 left 위치
   */
  var normalizeLeftPosition = (0, hooks_1.useCallback)(function (leftPosition, sizes) {
    var newLeftPosition;
    if (leftPosition > sizes.realWidth - sizes.containerWidth) {
      newLeftPosition = sizes.realWidth - sizes.containerWidth;
    } else if (leftPosition < 0) {
      newLeftPosition = 0;
    }
    return newLeftPosition;
  }, []);
  /**
   * 가능한 top 위치
   */
  var normalizeTopPosition = (0, hooks_1.useCallback)(function (topPosition, sizes) {
    var newTopPosition = topPosition;
    if (topPosition > sizes.realHeight - sizes.containerHeight) {
      newTopPosition = sizes.realHeight - sizes.containerHeight;
    }
    if (topPosition < 0) {
      newTopPosition = 0;
    }
    return newTopPosition;
  }, []);
  var computeLeftPosition = (0, hooks_1.useCallback)(function (deltaX, sizes) {
    var newLeftPosition = state.leftPosition - deltaX;
    return normalizeLeftPosition(newLeftPosition, sizes);
  }, [state.leftPosition]);
  /**
   * 상하스크롤 가능여부
   */
  var canScrollY = (0, hooks_1.useCallback)(function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : state;
    var scrollableY = value.realHeight > value.containerHeight;
    return scrollableY && props.vertical;
  }, []);
  /**
   * 좌우스크롤 가능여부
   */
  var canScrollX = (0, hooks_1.useCallback)(function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : state;
    var scrollableX = value.realWidth > value.containerWidth;
    return scrollableX && props.horizontal;
  }, []);
  /**
   * 스코롤 가능영부
   */
  var canScroll = (0, hooks_1.useCallback)(function (value) {
    return canScrollY(value) || canScrollX(value);
  }, []);
  var computeTopPosition = function computeTopPosition(deltaY, sizes) {
    var newTopPosition = state.topPosition - deltaY;
    return normalizeTopPosition(newTopPosition, sizes);
  };
  var composeNewState = (0, hooks_1.useCallback)(function (deltaX, deltaY) {
    var sizes = computeSizes();
    var newState = _objectSpread(_objectSpread({}, state), sizes);
    if (canScrollY(newState)) {
      newState.topPosition = computeTopPosition(deltaY, newState);
    } else {
      newState.topPosition = 0;
    }
    if (canScrollX(newState)) {
      newState.leftPosition = computeLeftPosition(deltaX, newState);
    }
    return newState;
  }, [computeTopPosition, computeLeftPosition, computeSizes]);
  var focusContent = (0, hooks_1.useCallback)(function () {
    if (contentRef.current) {
      contentRef.current.focus();
    }
  }, []);
  var scrollYTo = (0, hooks_1.useCallback)(function (topPosition) {
    if (canScrollY(state)) {
      var position = normalizeTopPosition(topPosition, computeSizes());
      setStateFromEvent({
        topPosition: position
      }, eventTypes.api);
    }
  }, [normalizeTopPosition, setStateFromEvent, computeSizes]);
  var scrollXTo = (0, hooks_1.useCallback)(function (leftPosition) {
    if (canScrollX()) {
      var position = normalizeLeftPosition(leftPosition, computeSizes());
      setStateFromEvent({
        leftPosition: position
      }, eventTypes.api);
    }
  }, [canScrollX, normalizeLeftPosition, computeSizes, setStateFromEvent]);
  var handleScrollbarMove = (0, hooks_1.useCallback)(function (deltaX, deltaY) {
    setStateFromEvent(composeNewState(deltaX, deltaY));
  }, [composeNewState, setStateFromEvent]);
  var handleScrollbarXPositionChange = (0, hooks_1.useCallback)(function (position) {
    scrollXTo(position);
  }, [scrollXTo]);
  var handleScrollbarYPositionChange = (0, hooks_1.useCallback)(function (position) {
    scrollYTo(position);
  }, [scrollYTo]);
  var handleWheel = (0, hooks_1.useCallback)(function (e) {
    /*
     * WheelEvent.deltaMode can differ between browsers and must be normalized
     * e.deltaMode === 0: The delta values are specified in pixels
     * e.deltaMode === 1: The delta values are specified in lines
     * https://developer.mozilla.org/en-US/docs/Web/API/WheelEvent/deltaMode
     */
    e.preventDefault();
    e.stopPropagation();
    // 방향 설정
    var deltaY = -e.deltaY;
    var deltaX = -e.deltaX;
    // deltaMode에 따른 스크롤량 설정
    if (e.deltaMode === 1) {
      deltaY *= getLineHeightPx();
      deltaX *= getLineHeightPx();
    } else if (e.deltaMode === 2) {
      deltaY *= getLineHeightPx() * 10;
      deltaX *= getLineHeightPx() * 10;
    }
    // 스크롤 속도 적용
    deltaY *= (props.speed || 1) * 0.79;
    deltaX *= (props.speed || 1) * 0.79;
    // 새로운 상태 계산
    var newState = composeNewState(deltaX, deltaY);
    if (newState.topPosition !== state.topPosition || newState.leftPosition !== state.leftPosition) {
      e.preventDefault();
      e.stopPropagation();
      setStateFromEvent(newState, eventTypes.wheel);
    }
    focusContent();
  }, [composeNewState, setStateFromEvent, focusContent]);
  var handleWindowResize = (0, hooks_1.useCallback)(function () {
    var newState = computeSizes();
    newState = getModifiedPositionsIfNeeded(newState);
    setStateFromEvent(newState);
  }, [computeSizes, getModifiedPositionsIfNeeded, setStateFromEvent]);
  var classes = "scrollarea ".concat(props.className || "");
  var contentClasses = "scrollarea-content ".concat(props.contentClassName || "");
  var contentStyle = {
    marginTop: -state.topPosition,
    marginLeft: -state.leftPosition
  };
  var withMotion = (0, hooks_1.useMemo)(function () {
    return props.smoothScrolling && (state.eventType === eventTypes.wheel || state.eventType === eventTypes.api || state.eventType === eventTypes.touchEnd || state.eventType === eventTypes.keyPress) ? true : false;
  }, [props.smoothScrolling, state.eventType]);
  var springifiedContentStyle = (0, hooks_1.useMemo)(function () {
    return withMotion ? (0, utils_1.modifyObjValues)(contentStyle, function (x) {
      return (0, preact_motion_1.spring)(x);
    }) : contentStyle;
  }, [withMotion, contentStyle]);
  var scrollbarY = (0, hooks_1.useMemo)(function () {
    return canScrollY(state) ? (0, preact_1.h)(ScrollBar_1.default, {
      ownerDocument: props.ownerDocument,
      realSize: state.realHeight,
      containerSize: state.containerHeight,
      position: state.topPosition,
      onMove: handleScrollbarMove,
      onPositionChange: handleScrollbarYPositionChange,
      containerStyle: props.verticalContainerStyle,
      scrollbarStyle: props.verticalScrollbarStyle,
      smoothScrolling: withMotion,
      minScrollSize: props.minScrollSize,
      onFocus: focusContent,
      type: "vertical"
    }) : null;
  }, [canScrollY, state]);
  var scrollbarX = canScrollX() ? (0, preact_1.h)(ScrollBar_1.default, {
    ownerDocument: props.ownerDocument,
    realSize: state.realWidth,
    containerSize: state.containerWidth,
    position: state.leftPosition,
    onMove: handleScrollbarMove,
    onPositionChange: handleScrollbarXPositionChange,
    containerStyle: props.horizontalContainerStyle,
    scrollbarStyle: props.horizontalScrollbarStyle,
    smoothScrolling: false,
    minScrollSize: props.minScrollSize,
    onFocus: focusContent,
    type: "horizontal"
  }) : null;
  return (0, preact_1.h)(preact_motion_1.Motion, {
    style: springifiedContentStyle
  }, [function (style) {
    return (0, preact_1.h)("div", {
      ref: wrapperRef,
      className: classes,
      style: props.style,
      onWheel: handleWheel,
      onMouseWheel: handleWheel
    }, (0, preact_1.h)("div", {
      ref: contentRef,
      style: _objectSpread(_objectSpread({}, props.contentStyle), style),
      className: contentClasses,
      role: "button",
      tabIndex: props.focusableTabIndex
    }, props.children), scrollbarY, scrollbarX);
  }]);
}
/**
 * 기본값
 */
var defaultProps = {
  className: null,
  style: null,
  speed: 1,
  contentClassName: null,
  contentStyle: null,
  vertical: true,
  verticalContainerStyle: null,
  verticalScrollbarStyle: null,
  horizontal: true,
  horizontalContainerStyle: null,
  horizontalScrollbarStyle: null,
  onScroll: null,
  smoothScrolling: false,
  minScrollSize: 0,
  swapWheelAxes: false,
  contentWindow: typeof window === "object" ? window : undefined,
  ownerDocument: typeof document === "object" ? document : undefined,
  stopScrollPropagation: false,
  focusableTabIndex: 1,
  children: null
};
ScrollArea.defaultProps = defaultProps;
exports.default = ScrollArea;